/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Zoeken',
  search_no_results_1: 'O nee.',
  search_no_results_2: 'Kan die emoji niet vinden',
  pick: 'Een emoji kiezen…',
  add_custom: 'Aangepaste emoji toevoegen',
  categories_activity: 'Activiteit',
  categories_custom: 'Aangepast',
  categories_flags: 'Vlaggen',
  categories_foods: 'Eten en drinken',
  categories_frequent: 'Vaak gebruikt',
  categories_nature: 'Dieren en natuur',
  categories_objects: 'Voorwerpen',
  categories_people: 'Smileys en mensen',
  categories_places: 'Reizen en plaatsen',
  categories_search: 'Zoekresultaten',
  categories_symbols: 'Symbolen',
  skins_choose: 'Kies uw standaard huidtint',
  skins_1: 'Standaard',
  skins_2: 'Licht',
  skins_3: 'Medium-licht',
  skins_4: 'Medium',
  skins_5: 'Medium-donker',
  skins_6: 'Donker',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
